<template>
    <div
        v-if="list.length"
        class="pagination"
    >
        <div
            class="pagination-btn pagination__prev"
            @click="prevPage"
        >
            <img
                src="@/assets/images/arrow_left.svg"
                alt="left"
            >
        </div>
        <div class="pagination-pages">
            <div
                v-for="page in pageCount"
                :key="page"
                class="pagination-page"
                :class="{'is-active': page === pageNumber + 1}"
                @click="onClickPage(page)"
            >
                <span>{{ page }}</span>
            </div>
        </div>
        <div
            class="pagination-btn pagination__next"
            @click="nextPage"
        >
            <img
                src="@/assets/images/arrow_right.svg"
                alt="right"
            >
        </div>
    </div>
</template>
<script>
export default {
    name: 'PaginationBar',
    props: {
        list: {
            type: Array,
            default: () => []
        },
        size: {
            type: Number,
            default: 10
        }
    },
    emits: ['changePage'],
    data () {
        return {
            pageNumber: 0
        }
    },
    computed: {
        pageCount() {
            if(!this.list.length) return 0
            return Math.ceil(this.list.length / this.size)
        },
        paginatedData() {
            if(!this.list || !this.list.length) return []
            const start = this.pageNumber * this.size;
            const end = start + this.size
            return this.list.slice(start, end)
        }
    },
    mounted() {
        this.$emit('changePage', this.paginatedData)
        this.$watch('list', (newValue, oldValue) => {
            if(newValue !== oldValue) {
                this.$emit('changePage', this.paginatedData)
                this.pageNumber = 0
            }
        }, { deep: true })
    },
    methods: {
        onClickPage(page) {
            this.pageNumber = page - 1
            this.$emit('changePage', this.paginatedData)
        },
        nextPage() {
            if(this.pageNumber + 1 < this.pageCount) {
                this.pageNumber++
                this.$emit('changePage', this.paginatedData)
            }
        },
        prevPage() {
            if(this.pageNumber + 1 > 1) {
                this.pageNumber--
                this.$emit('changePage', this.paginatedData)
            }
        },
    },
}
</script>
<style scoped>
.pagination {
    display: flex;
    align-items: center;
    column-gap: 20px;
}
.pagination .pagination-pages {
    display: flex;
    align-items: center;
}
.pagination .pagination-page {
    width: 26px;
    height: 26px;
    border-radius: 4px;
    transition: .3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.pagination .pagination-page:hover {
    background: #F3F7FB;
}
.pagination .pagination-page.is-active {
    color: var(--primary-blue);
}
.pagination-btn {
    font-size: 0;
    padding: 5px;
    cursor: pointer;
    transition: .3s ease-in-out transform;
}
.pagination-btn img {
    width: 8px;
    height: 14px;
    object-fit: cover;
}
.pagination__prev:hover {
    transform: translateX(-5px);
}
.pagination__next:hover {
    transform: translateX(5px);
}
</style>
